export const participantTypes = {
  individual: "Individual",
  attorney: "Attorney",
  paralegal: "Paralegal",
  expert: "Expert",
  judge: "Judge",
};
export type ParticipantType =
  (typeof participantTypes)[keyof typeof participantTypes];
